import React, { useState, useEffect } from "react";
import { AddToCartButton } from "../poi/AddToCartButton";
import { ReactComponent as ArrowRightSvg } from "../logo/ArrowRight.svg";
import { CancelToken } from "axios";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";

import { CreateItinButton } from "./CreateItinButton";
import { ReactComponent as DeleteIcon } from "../logo/Delete.svg";
import { get, post } from "../common/api";

import noItinAssetImage from "./assets/no-itin.png";
import "./ItinPage.css";

export const DEFAULT_ERROR_MESSAGE =
  "Terjadi suatu kesalahan, silahkan coba lagi.";

export function ItinPage(props) {
  const auth = useSelector((state) => state.auth);
  const history = useHistory();
  const alert = useAlert();

  const [isLoading, setIsLoading] = useState(true);
  const [itinList, setItinList] = useState(null);

  const onDeleteFunction = (itinIndex) => async () => {
    const itin = itinList[itinIndex];
    const confirmed = window.confirm(
      `Apakah kamu yakin mau menghapus itinerary ${itin.name}?`
    );
    if (!confirmed) return;
    setIsLoading(true);
    try {
      const source = CancelToken.source();
      await post(
        "/api/remove-itin/",
        { trip_id: itin.id },
        {
          cancelToken: source.cancelToken,
          headers: {
            Authorization: `Token ${auth.token}`,
          },
        }
      );
      setItinList(itinList.filter((_, i) => i !== itinIndex));
      alert.success(`Sukses menghapus Itinerary ${itin.name}`);
    } catch (e) {
      const message = e.response?.data?.message || DEFAULT_ERROR_MESSAGE;
      alert.error(message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (!auth.token) {
      alert.info(
        "Silahkan login terlebih dahulu untuk melihat page Itinerary."
      );
      history.push("/login");
      return;
    }

    const source = CancelToken.source();
    async function fetchData() {
      try {
        const res = await get(`/api/itin-list/`, {
          cancelToken: source.cancelToken,
          validateStatus: (status) => {
            if (status >= 200 && status < 300) return true; // 2xx
            if (status >= 400 && status < 500) return true; // 4xx
            return false;
          },
          headers: {
            Authorization: `Token ${auth.token}`,
          },
        });
        await setItinList(
          res.status >= 200 && res.status < 300 ? res.data : []
        );
      } catch (e) {
        const message = e.response?.data?.message || DEFAULT_ERROR_MESSAGE;
        alert.error(message);
      }
      setIsLoading(false);
    }
    fetchData();
    return () => {
      source.cancel();
    };
  }, [auth, history, alert]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-self-center align-items-center w-100 h-100">
        <div className="spinner-border" role="status" />
      </div>
    );
  }
  if (itinList && itinList.length > 0)
    return (
      <ItinListComponent
        itinList={itinList}
        onDeleteFunction={onDeleteFunction}
      />
    );
  return <NoItinComponent />;
}

function NoItinComponent(props) {
  return (
    <div className="container-sm no-itin-container">
      <img
        src={noItinAssetImage}
        alt="no-itinerary-asset"
        className="no-itinerary-image w-50-lg w-75-sm"
      />
      <div className="headline">ITIN masih kosong nih ..</div>
      <div className="subhead">
        Kamu belum punya ITIN, buat rencana perjalananmu sekarang dengan Liwat
        ITIN.
      </div>
      <CreateItinButton />
    </div>
  );
}

function ItinListComponent(props) {
  const { itinList, onDeleteFunction } = props;
  return (
    <div className="itin-list-container">
      <div className="itin-list-container-header flex-column flex-md-row">
        <h3 className="mb-1 mb-md-2">Itinerary Saya</h3>
        <CreateItinButton />
      </div>
      {itinList.map((itinRow, i) => (
        <ItinRowComponent
          key={`itin-row-${itinRow.id}`}
          {...itinRow}
          onDelete={onDeleteFunction(i)}
        />
      ))}
    </div>
  );
}

function ItinRowComponent(props) {
  const { onDelete } = props;
  return (
    <div
      className="itin-row-container flex-md-row flex-column"
      testid="itin-row"
    >
      <img src={props.image} alt={`itin-row-${props.id}`} />
      <div className="itin-row-details-container flex-lg-row flex-column align-items-lg-center align-items-start">
        <div>
          <div className="itin-row-name headline mt-md-0 mt-3">
            Itinerary {props.name}
          </div>
          <div className="itin-row-time">
            {props.start_time} - {props.end_time}
          </div>
          <Link to={`/itin/${props.id}`} className="see-more">
            <span>Lihat selengkapnya</span>
            <ArrowRightSvg />
          </Link>
        </div>
        <div className="itin-action-buttons d-flex flex-md-row flex-column mt-3 mt-md-0">
          <AddToCartButton type="bundle" {...props} />
          <button
            className="delete-button ml-md-3 mt-3 mt-md-0"
            onClick={onDelete}
          >
            <DeleteIcon />
            <span>Hapus</span>
          </button>
        </div>
      </div>
    </div>
  );
}
